var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgTableArrow = function SvgTableArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#table-arrow_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.476 4.524L3.146.2A.671.671 0 002 .673v8.654c0 .599.723.898 1.147.474l4.329-4.325a.674.674 0 000-.952z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "table-arrow_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10v10H0V0z"
  })))));
};

export default SvgTableArrow;